import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from "@angular/router";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
  imports: [RouterLink],
  standalone: true,
})
export class BreadcrumbComponent {
  @Input() breadcrumbItems: { label: string, link?: string }[] = [];
}
